import React, { FC } from 'react';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import { faUser as faProfile } from '@fortawesome/free-solid-svg-icons';
import './SwitchToProfile.css';

export interface SwitchToProfileProps {
	refSearch: React.RefObject<HTMLDivElement>,
    refProfile: React.RefObject<HTMLDivElement>,
};

const SwitchToProfile: FC<SwitchToProfileProps> = ({ refSearch, refProfile }) => {

    const onClick = (e: React.MouseEvent) => {
        e.stopPropagation();
        if(refSearch.current) {
            refSearch.current.className = 'Left';
            refSearch.current.style.zIndex = '0';
        }
        if(refProfile.current) {
            refProfile.current.className = 'Right appear';
            refProfile.current.style.zIndex = '10';
        }
    };

    return (
		<div className='SwitchToProfile' onClick={onClick}>
            <Icon icon={faProfile} fixedWidth/>
	    </div>
    );
};

export default SwitchToProfile;
